import PageCollection from '../../base/collections/page';

module.exports = PageCollection.extend({
  state: {
      pageSize: 20,
      pagesInRange: 10
  }
});



// WEBPACK FOOTER //
// ./parentpay/collections/contact.js